import { useState, useEffect} from 'react';
import api from '../../../config.js';
import './features.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaSearch, FaEye, FaArrowLeft, FaArrowRight, FaCog } from 'react-icons/fa';
import { makeSearch, getPermission, activeMask, showMessageError } from '../../../classes/functions';
import { Link } from 'react-router-dom';
import ReactTooltip from "react-tooltip";

export default function Features(){
  const [list, setList] = useState([]);
  const [carrying, setCarrying] = useState(true);

  useEffect(()=> {
    async function loadFeatures(){
      api.get("/api/features/getList")
      .then((response) => {
        setList(response.data);
        setCarrying(false);
        }
      ).catch((error) => {
        console.log(error);
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }

    loadFeatures();

    return () => {

    }
  }, []);
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Características">
          {getPermission('CONFIGURACOES - CARACTERISTICAS - CADASTRO') && <Link to="/features/cadastrar">
            <button className="buttonInsert">
              Cadastrar
            </button> 
          </Link>}
        </Title>

        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">Descrição</th>
                <th scope="col">Nome</th>
                <th scope="col">Ativo</th>
                <th scope="col" className='collumOption'>Opções</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="Descricao">{item.descricao}</td>
                    <td data-label="Observação">{item.fluxo}</td>
                    <td data-label="Ativo">{activeMask(item.ativo)}</td>
                    <td data-label="Opções">
                      {getPermission('CONFIGURACOES - CARACTERISTICAS - CADASTRO') && <Link className="action" to={`/features/cadastrar/u${item.chave}`} >
                        <FaPen color="#000" size={17} />
                      </Link>}
                      <Link className="action" to={`/features/cadastrar/v${item.chave}`} >
                        <FaEye color="#000" size={19} />
                      </Link>
                    </td> 
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={4}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
      </div>}
    </div>
  )
}